import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReviewCard from "./review-card";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const Reviews = ({ description }) => {
	const [reviews, setReviews] = useState([]);

	useEffect(() => {
		axios
			.get(
				`https://www.local-marketing-reports.com/external/showcase-reviews/widgets/754f56dd8231f9069c570eaacfc32352f1f512a9`
			)
			.then((res) => {
				const reviewData = res.data.results;
				setReviews(reviewData);
				setReviews(reviewData);
				document.getElementById("loading-spinner").style.display = "none";
			});
	});
	return (
		<Container className="text-start text-md-center ">
			<h2 className="underline mb-3 fs-2 fs-lg-1 d-none d-md-inline-block">
				What my clients say about me
			</h2>

			<h4 className="underline mb-3 d-md-none">What my clients say about me</h4>
			<p className="px-lg-10">{description}</p>
			<div>
				<Col>
					<Row className="px-0 mx-0 justify-content-center">
						<Spinner
							id="loading-spinner"
							variant="primary"
							animation="border"
							className="mt-10"
						></Spinner>
						{reviews
							.filter((item, index) => index <= 1)
							.map((review) => (
								<Col xl={4} md={6} xs={12} className="mx-0">
									<ReviewCard review={review} />
								</Col>
							))}
						{reviews
							.filter((item, index) => index === 2)
							.map((review) => (
								<Col xl={4} xs={12} className="mx-0">
									<ReviewCard review={review} />
								</Col>
							))}
					</Row>
				</Col>
			</div>
		</Container>
	);
};

export default Reviews;
